import { useContext } from "react";
import WelcomeJourneyContext from "../contexts/WelcomeJourneyProvider";

const useWelcomeJourney = () => {
    return useContext(WelcomeJourneyContext);
};

export default useWelcomeJourney;